export default __webpack_public_path__ + "static/1.2_EN-ce234a92cbcb752d8a107b5bcbdb0ae3.webp";